import React from "react";
import * as Styles from "./styles.js";

function Footer() {
  return <Styles.Footer>&copy; 2021 Steve Meredith</Styles.Footer>;
}

export default Footer;
